export function Blob_toBase64Async(blob: Blob): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            if (typeof reader.result === "string") {
                resolve(reader.result);
            } else {
                reject("Failed to convert the blob to base64");
            }
        };

        reader.onerror = () => {
            reject("Failed to read the blob");
        };

        reader.readAsDataURL(blob);
    });

    return promise;
}
